import React from 'react'
import PropTypes from 'prop-types'

import { Item } from '@generators/htmlComponents/Item'
import { SecondaryTitle } from '@generators/htmlComponents/SecondaryTitle'
import {
  getIdealWeight
} from '@util/equationsUtil'

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
}

const AnthropometricMeasures = ({
  weight,
  height,
  hipCircumference,
  abdominalCircumference,
  waistCircumference,
}) => {
  const idealWeight = height ? getIdealWeight(height) : 0
  return (
    <>
      <SecondaryTitle text="Medidas antropométricas" />
      <div style={styles.section}>
        <Item label="Altura" text={`${height} cm`} />
        <Item label="Peso" text={`${weight} kg`} />
        {Number(idealWeight) > 0 ? (
          <Item label="Peso Ideal" text={`${idealWeight} kg`} />
        ) : (
          <Item label="Peso Ideal" text="-" />
        )}
      </div>
      <div style={styles.section}>
        <Item
          label="Circ. abdominal"
          text={
            abdominalCircumference
              ? `${abdominalCircumference} cm`
              : 'Não coletado'
          }
        />
        <Item
          label="Circ. cintura"
          text={
            waistCircumference ? `${waistCircumference} cm` : 'Não coletado'
          }
        />
        <Item
          label="Circ. quadril"
          text={hipCircumference ? `${hipCircumference} cm` : 'Não coletado'}
        />
      </div>
    </>
  )
}

AnthropometricMeasures.propTypes = {
  weight: PropTypes.number,
  height: PropTypes.number,
  hipCircumference: PropTypes.number,
  abdominalCircumference: PropTypes.number,
  waistCircumference: PropTypes.number,
}

AnthropometricMeasures.defaultProps = {
  weight: 0,
  height: 0,
  hipCircumference: null,
  abdominalCircumference: null,
  waistCircumference: null,
}

export default AnthropometricMeasures
